export default __webpack_public_path__ + "static/media/face_with_rolling_eyes.1f6873ea.png";